import { useUser } from "../useUser";

export const useLinkedAccounts = () => {
  const { allstarUser } = useUser();
  const hasRiotLinked = !!allstarUser?.user?.riot?.puuid;
  const hasSteamLinked = !!allstarUser?.user?.steam?.steamid;
  const hasFaceitLinked = !!allstarUser?.user?.faceit?.nickname;
  const hasEpicLinked = !!allstarUser?.user?.epic?.id;

  return {
    hasRiotLinked,
    hasSteamLinked,
    hasFaceitLinked,
    hasEpicLinked,
  };
};
